
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/[[...tag]]",
      function () {
        return require("private-next-pages/onboarding/[[...tag]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding/[[...tag]]"])
      });
    }
  